import { QuotationService } from './../../models/quote.model';
import { Warranty } from 'src/app/models/warranty.model';
import { UtilsService } from 'src/app/services/utils.service';
import { DocumentsService } from './../../services/documents.service';
import { Installment } from './../../models/installment.model';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorResponse } from 'src/app/models/error.model';

@Component({
  selector: 'app-services-payment-dialog',
  templateUrl: './services-payment-dialog.component.html',
  styleUrls: ['./services-payment-dialog.component.scss']
})
export class ServicesPaymentDialogComponent implements OnInit {

  constructor(
    private documentsService: DocumentsService,
    private utilsService: UtilsService,
    public dialogRef: MatDialogRef<ServicesPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { installment: Installment, warranty: Warranty }
  ) { }

  ngOnInit(): void {
  }

  cerrarDialogo() {
    this.dialogRef.close(this.data.installment);
  }

  findDocument(service: QuotationService) {
    return this.data.installment.comprobantes.find(comprobante => comprobante.tipo === 'COMPROBANTE_PAGO_SERVICIOS' && comprobante.categoria === String(service.id));
  }

  getStatus(service: QuotationService) {
    return this.findDocument(service) ? 'PAGADO' : 'PENDIENTE';
  }

  downloadDocument(service: QuotationService) {
    const document = this.findDocument(service);
    if (document) {
      this.documentsService.downloadDocument(document.id).subscribe(awsRequest => {
        this.utilsService.downloadFile(awsRequest);
      }, (error: ErrorResponse) => this.utilsService.alert('Error al descargar archivo', error.error?.descripcion));
    }
  }

}
